import apiClient from './Api';
const PREFIX = '/featureBanners';

const getBannerTemplates = postData =>
  apiClient({
    url: `${PREFIX}/getBannerTemplates`,
    method: 'POST',
    data: postData
  });

const addBannerTemplate = postData =>
  apiClient({
    url: `${PREFIX}/saveTemplate`,
    method: 'POST',
    data: postData
  });

const deleteBannerTemplate = postData =>
  apiClient({
    url: `${PREFIX}/deleteTemplate`,
    method: 'POST',
    data: postData
  });

const getDealerBanner = postData =>
  apiClient({
    url: `${PREFIX}/getDealerBanner`,
    method: 'POST',
    data: postData
  });

const saveDealerBanner = postData =>
  apiClient({
    url: `${PREFIX}/saveDealerBanner`,
    method: 'POST',
    data: postData
  });

const FeatureBannersService = {
  getBannerTemplates,
  addBannerTemplate,
  deleteBannerTemplate,
  getDealerBanner,
  saveDealerBanner
};

export default FeatureBannersService;
